import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'
import { Fragment } from 'react'
import FilterHeader from './FilterHeader'
import FilterBody from './FilterBody'
import ChatBody from './ChatBody'
import ChatFooter from './ChatFooter'
import ChatHeader from './ChatHeader'
import ChatModalStatus from './ChatModalStatus'
import ChatModalForward from './ChatModalForward'
import ChatModalAttachment from './ChatModalAttachment'
import jwt from 'jwt-decode'
import { ContentBodyContext } from '../MainContent'
import { AuthContext } from '../../../App/App'
import swal from 'sweetalert';


export const WhatsappContext = createContext();

function Whatsapp() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const initialRecuder = {
        filter: "all", //filter chat list,
        filterSub: null,
        endpoint: `/api/v1/helpdesk/whatsapp/chats/client/all`, //endpoint filter
        chats: [], //all chat
        chat: { header: [], body: [] }, //chat detail
        trigger: { message: null }, //additional trigger
        active: null, //parent id chat
        statusChat: null, //status chat 
        chatcategory: { category: '', client: '' },
        modalattach: { status: false },
        modalstatus: { status: false },
        modalforward: { status: false, chat: null },
    }
    const reducer = (state, action) => {
        switch (action.type) {
            case "FILTER":
                return {
                    ...state,
                    filter: action.filter,
                    filterSub: action.filterSub,
                    endpoint: action.endpoint
                }
            case "ERROR":
                return {
                    ...state,
                    error: action.error,
                }
            case "CHATS":
                return {
                    ...state,
                    chats: action.payload,
                }
            case "CHAT":
                return {
                    ...state,
                    chat: action.payload,
                }
            case "TRIGGER":
                return {
                    ...state,
                    trigger: action.trigger,
                }
            case "ACTIVE":
                return {
                    ...state,
                    active: action.active,
                }
            case "STATUS":
                return {
                    ...state,
                    statusChat: action.statusChat,
                }
            // case "CLOSE":
            //     return {
            //         ...state,
            //         trigger: action.statusChat,
            //         chats: action.chats,
            //         active: action.active,
            //         chat: action.chat
            //     }
            case "CHATCATEGORY":
                return {
                    ...state,
                    chatcategory: action.chatcategory
                }
            case "MODALATTACH":
                return {
                    ...state,
                    modalattach: action.modalattach
                }
            case "MODALSTATUS":
                return {
                    ...state,
                    modalstatus: action.modalstatus
                }
            case "MODALFORWARD":
                return {
                    ...state,
                    modalforward: action.modalforward
                }
            default:
                return state
        }
    }
    const [stateWhatsApp, dispatchWhatsApp] = useReducer(reducer, initialRecuder)

    const [tempResult, settempResult] = useState(null)
    useEffect(() => {
        //admin message
        stateContentBody.socket.on(`whatsapp-chat-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'whatsapp-chat', status: 'success', res: { action: res.action, data: res.data } }
            })
        })

        stateContentBody.socket.on(`whatsapp-chat-error-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'whatsapp-chat', status: 'error', res: { action: res.action, data: null } }
            })
            if (res.message == `jwt expired`) {
                dispatchAuth({
                    type: "LOGOUT",
                    message: 'Token expired, please login again...'
                })
            } else {
                swal("Error!", `${res.message.replace('jwt', 'Token')}`, "error", {
                    button: "OK",
                });
            }
        })

        //new messge from user
        stateContentBody.socket.on(`new-message-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'new-whatsapp-chat', status: 'success', res: { action: res.action, data: res.data } }
            })
        })

        //update status
        stateContentBody.socket.on(`whatsapp-status-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'whatsapp-status', status: 'success', res: { action: res.action, data: res.data } }
            })
        })

        stateContentBody.socket.on(`whatsapp-status-error${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'whatsapp-status', status: 'error', res: { action: res.action, data: null } }
            })
            if (res.message == `jwt expired`) {
                dispatchAuth({
                    type: "LOGOUT",
                    message: 'Token expired, please login again...'
                })
            } else {
                swal("Error!", `${res.message.replace('jwt', 'Token')}`, "error", {
                    button: "OK",
                });
            }
        })

        //close chat
        //close message
        stateContentBody.socket.on(`whatsapp-chat-close-${jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id}`, function (res) {
            dispatchWhatsApp({
                type: 'TRIGGER',
                trigger: { message: 'whatsapp-chat-close', status: 'success', res: { action: res.action, data: res.data } }
            })
        })

        //close status

    }, [])

    const initialState = (
        <Fragment>
            <div className="card-body" style={{ minHeight: '80vh' }}>
                <div className="empty-state col-12">
                    <img style={{ maxWidth: '350px' }} src="./assets/img/products/drawkit-full-stack-man-colour.svg" alt="image" />
                    <h2 style={{ fontSize: '40px' }} className="mt-0  pt-10">We can't reach the service</h2>
                    <p style={{ fontSize: '20px' }} className="lead">
                        Whatsapp disconnected, contact the administrator to obtain permission.
                    </p>
                </div>
            </div>
        </Fragment>
    )
    const [renderWhatsapp, setrenderWhatsapp] = useState(initialState)
    useEffect(() => {
        if (stateContentBody.whatsappAuth.status == true) {
            setrenderWhatsapp(
                <Fragment>
                    <div className="section-title mt-0  ml-3 pb-1">
                        {stateAuth.page}
                    </div>
                    <div className="tickets" >
                        <div className="ticket-items p-0 m-1"  >
                            <div className="card chat-box card-success mb-0 pb-0" id="mychatbox2" style={{ minHeight: '80vh' }}>
                                <WhatsappContext.Provider value={{ stateWhatsApp, dispatchWhatsApp }}>
                                    <FilterHeader />
                                    <FilterBody />
                                </WhatsappContext.Provider>
                            </div>
                        </div>
                        <div className="ticket-content p-0 m-1">
                            <div className="ticket-description">
                                <div className="card chat-box card-success  mb-0 pb-0" id="mychatbox2" style={{ minHeight: '80vh' }}>
                                    <WhatsappContext.Provider value={{ stateWhatsApp, dispatchWhatsApp }}>
                                        <ChatHeader />
                                        <ChatBody />
                                        <ChatFooter />
                                    </WhatsappContext.Provider>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        }
        else {
            setrenderWhatsapp(initialState)
        }
    }, [stateContentBody.whatsappAuth.status, stateWhatsApp.trigger, stateWhatsApp])

    return (
        <Fragment>
            <div className="section-body">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0 mt-2 ml-0 mr-0">
                                {renderWhatsapp}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <WhatsappContext.Provider value={{ stateWhatsApp, dispatchWhatsApp }}>
                <ChatModalAttachment />
                <ChatModalStatus />
                <ChatModalForward />
            </WhatsappContext.Provider>

        </Fragment>
    )
}

export default Whatsapp
